import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	token: undefined,
	error: undefined,
	hasBeenSubmitted: false,
	isSubmitting: false
};

export const tokenSlice = createSlice({
	name: 'token',
	initialState,
	reducers: {
		submitToken: (state) => {
			state.isSubmitting = true;
		},
		submitTokenCompleted: (state, action) => {
			state.isSubmitting = false;
			state.hasBeenSubmitted = true;
			state.token = action.payload?.token;
		},
		submitTokenFailed: (state, action) => {
			state.isSubmitting = false;
			state.error = action.payload?.response?.data?.message || action.payload.message;
		}
	}
});

export const { submitToken, submitTokenCompleted, submitTokenFailed } = tokenSlice.actions;

export default tokenSlice.reducer;
